export enum ChangeType {
	INITIAL = 'initial',
	JOB_CHANGE = 'jobChange',
	JOB_DELETED = 'jobDeleted',
	UNIT_PERIO_CHANNEL = 'unitPeriodChannel',
	USER_UNIT_PERIOD_CHANNEL = 'userUnitPeriodChannel',
	UNIT_PERIO_CHANNEL_OFFSET = 'unitPeriodChannelOffset',
	JOB_COMMENT = 'jobComment',
	SETTING_CHANGE = 'settingChange',
	SYNC_CHANGE = 'syncChange',
	JOB_DAILY_REPORT = 'jobDailyReport',
	SPLIT_MERGE = 'splitMerge',
}
